import { render } from "./DetailDemande.vue?vue&type=template&id=37c9b2da&ts=true"
import script from "./DetailDemande.vue?vue&type=script&lang=ts"
export * from "./DetailDemande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__